module.exports = __webpack_public_path__ + "media/images/registration_bank_card_and_note-f61e65f88908d47beee1ed3ac55fd780.png";